const VideoUtilityService = {
  // 4 link formats::
  //  contains 'v='
  //  contains 'youtu.be/'
  //  contains 'youtube.com/live/'
  //  contains 'youtube.com/embed/' (This is the format needed)
  extractYoutubeLinkID: (link: string): string => {
    if (!link) return '';

    try {
      // Normalize to a URL (adds protocol if missing)
      const url = link.startsWith('http') ? new URL(link) : new URL('https://' + link);

      const host = url.hostname.replace(/^www\./, '');
      const path = url.pathname.replace(/^\/+/, ''); // no leading slash
      const params = url.searchParams;

      // Standard watch URL: youtube.com/watch?v=ID
      if (
        (host === 'youtube.com' || host === 'm.youtube.com' || host === 'youtu.be') &&
        params.has('v')
      ) {
        return params.get('v') || '';
      }

      // youtu.be/ID
      if (host === 'youtu.be') {
        // path may include extra segments; first segment is ID
        return (path.split('/')[0] || '').split('?')[0].split('&')[0];
      }

      // youtube.com/embed/ID, youtube.com/live/ID, youtube.com/shorts/ID
      const PATH_PREFIXES = ['embed', 'live', 'shorts'];
      const [prefix, maybeId] = path.split('/');
      if (
        (host === 'youtube.com' || host === 'm.youtube.com') &&
        PATH_PREFIXES.includes(prefix) &&
        maybeId
      ) {
        return maybeId.split('?')[0].split('&')[0];
      }

      // Fallback: last resort regex
      const m = link.match(/(?:v=|youtu\.be\/|embed\/|live\/|shorts\/)([A-Za-z0-9_-]{8,})/);
      return m ? m[1] : '';
    } catch {
      // Non-URL strings (e.g., just an ID)
      const looksLikeId = /^[A-Za-z0-9_-]{8,}$/.test(link);
      return looksLikeId ? link : '';
    }
  },
};

export default VideoUtilityService;
